import { isOnNodeJS } from "common/utils/context";
import type { PropAsset } from "./PropAsset";
import { loadPropLibrary } from "./propLibraryRuntime";
import { type PropLibrarySource, propLibrarySourceFromString } from "./PropLibrarySource";

export function propLibrarySourceFromURLParams(): PropLibrarySource {
  if (typeof window === "undefined") {
    // Network-isolated generators can use the prop library bundled with their image.
    return propLibrarySourceFromString(process.env.HIGHARC_PROP_LIBRARY_SOURCE);
  }
  const searchParams = new URLSearchParams(window.location.search);
  return propLibrarySourceFromString(searchParams.get("propLibrary"));
}

/** Starts loading the browser's prop library without making the caller wait for it. */
export function preloadBuiltinPropLibrary(): void {
  if (isOnNodeJS()) {
    return;
  }

  void loadPropLibrary(propLibrarySourceFromURLParams()).catch(() => undefined);
}

export async function getBuiltinProp(
  id: string | number,
  propLibrarySource: PropLibrarySource = propLibrarySourceFromURLParams(),
): Promise<PropAsset | undefined> {
  const builtinPropLibrary = await loadPropLibrary(propLibrarySource);
  if (typeof id === "string") {
    id = parseInt(id);
  }
  return builtinPropLibrary.has(id) ? builtinPropLibrary.get(id) : undefined;
}
